import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Product } from '~shared/models';
import { Direction, DirectionType, NUMBER_6 } from '~shared/constants';
import { PriceTypes } from '~shared/modules/price-type-toggler/price-type-toggler.module';
import { OnProductClickEvent, OnSwipeEvent } from '~app/modules/storyblok/models';
import { COLOR_CLASSES } from '~app/modules/storyblok/constants';

@Component({
  selector: 'app-advanced-title-carousel',
  templateUrl: './title-carousel.component.html',
  styleUrls: ['../advanced-carousel.component.scss', './title-carousel.component.scss'],
})
export class TitleCarouselComponent implements OnChanges {
  @Input() title: string;
  @Input() isPromo: boolean;
  @Input() colorClass: string;
  @Input() products: Array<Product>;
  @Input() pageType: string;
  @Input() isMobile?: boolean;
  @Input() isTablet?: boolean;
  @Input() isDesktop?: boolean;
  @Input() isLandScapeTablet?: boolean;
  @Input() trackingName: string;
  @Output() onProductClick: EventEmitter<OnProductClickEvent> = new EventEmitter();
  @Output() onNavigate: EventEmitter<OnSwipeEvent> = new EventEmitter();
  @Output() onSwipe: EventEmitter<OnSwipeEvent> = new EventEmitter();

  readonly NUMBER_6 = NUMBER_6;
  computedClasses: { [key: string]: boolean } = {};
  hasEndPadding: boolean = false;
  DIRECTION = Direction;

  ngOnChanges(_changes: SimpleChanges) {
    this.computedClasses = {
      [this.colorClass]: !!this.colorClass,
      'advanced-carousel__title-plus-carousel__colored':
        !!this.colorClass || (!!this.colorClass && this.colorClass !== COLOR_CLASSES.white),
    };

    this.hasEndPadding =
      !!this.colorClass || (!this.colorClass && (this.isMobile || this.isTablet || this.isLandScapeTablet));
  }

  onProductClickEvent(product: Product, priceType: PriceTypes, productIndex: number): void {
    this.onProductClick.emit({ product, priceType, productIndex });
  }

  onProductCarouselNavigation(direction: DirectionType): void {
    this.onNavigate.emit({ direction });
  }

  onProductCarouselSwipe(direction: DirectionType): void {
    this.onSwipe.emit({ direction });
  }
}
